<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, email } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';
import WootDateRangePicker from 'dashboard/components/ui/DateRangePicker.vue';

export default {
  components: {
    WootDateRangePicker,
  },
  //mixins: [alertMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['cancel', 'update:show'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      email: '',
      selectedType: '',
      isSubmitting: false,
      range: [new Date(), new Date()],
      customRangeTranscript: false,
    };
  },
  validations: {
    email: {
      required,
      email,
      minLength: minLength(4),
    },
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    sentToOtherEmailAddress() {
      return this.selectedType === 'other_email_address';
    },
    isFormValid() {
      if (this.selectedType) {
        if (this.sentToOtherEmailAddress) {
          return !!this.email && !this.v$.email.$error;
        }
        return true;
      }
      return false;
    },
    selectedEmailAddress() {
      const { meta } = this.currentChat;
      switch (this.selectedType) {
        case 'contact':
          return meta.sender.email;
        case 'assignee':
          return meta.assignee.email;
        case 'other_email_address':
          return this.email;
        default:
          return '';
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onCustomDateRangeChange(value) {
      this.range = value;
    },
    async onSubmit() {
      this.isSubmitting = false;
      try {
        await this.$store.dispatch('sendEmailTranscript', {
          email: this.selectedEmailAddress,
          conversationId: this.currentChat.id,
          range: this.customRangeTranscript ? this.range : null,
        });
        useAlert(this.$t('EMAIL_TRANSCRIPT.SEND_EMAIL_SUCCESS'));
        this.onCancel();
      } catch (error) {
        useAlert(this.$t('EMAIL_TRANSCRIPT.SEND_EMAIL_ERROR'));
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
<!-- eslint-disable vue/no-mutating-props -->
<template>
  <woot-modal v-model:show="localShow" :on-close="onCancel">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        :header-title="$t('EMAIL_TRANSCRIPT.TITLE')"
        :header-content="$t('EMAIL_TRANSCRIPT.DESC')"
      />
      <form class="w-full" @submit.prevent="onSubmit">
        <div class="flex items-center gap-2 mb-5">

          <div class="flex items-center gap-2">
            <div>
              <label>{{ $t('EMAIL_TRANSCRIPT.CUSTOM_DATE_RANGE') }}</label>
            </div>
            <div>
              <woot-switch v-model="customRangeTranscript" />
            </div>
          </div>

          <div v-if="customRangeTranscript" class="w-6/12">
            <woot-date-range-picker
              class="no-margin auto-width"
              :value="range"
              :confirm-text="$t('REPORT.CUSTOM_DATE_RANGE.CONFIRM')"
              :placeholder="$t('REPORT.CUSTOM_DATE_RANGE.PLACEHOLDER')"
              @change="onCustomDateRangeChange"
            />
          </div>
        </div>
        <div
          v-if="currentChat.meta.sender && currentChat.meta.sender.email"
          class="flex items-center gap-2"
        >
          <input
            id="contact"
            v-model="selectedType"
            type="radio"
            name="selectedType"
            value="contact"
          />
          <label for="contact">{{
              $t('EMAIL_TRANSCRIPT.FORM.SEND_TO_CONTACT')
            }}</label>
        </div>
        <div v-if="currentChat.meta.assignee" class="flex items-center gap-2">
          <input
            id="assignee"
            v-model="selectedType"
            type="radio"
            name="selectedType"
            value="assignee"
          />
          <label for="assignee">{{
              $t('EMAIL_TRANSCRIPT.FORM.SEND_TO_AGENT')
            }}</label>
        </div>
        <div class="flex items-center gap-2">
          <input
            id="other_email_address"
            v-model="selectedType"
            type="radio"
            name="selectedType"
            value="other_email_address"
          />
          <label for="other_email_address">{{
              $t('EMAIL_TRANSCRIPT.FORM.SEND_TO_OTHER_EMAIL_ADDRESS')
            }}</label>
        </div>
        <div v-if="sentToOtherEmailAddress" class="w-[50%] mt-1">
          <label :class="{ error: v$.email.$error }">
            <input
               v-model="email"
              type="text"
              :placeholder="$t('EMAIL_TRANSCRIPT.FORM.EMAIL.PLACEHOLDER')"
              @input="v$.email.$touch"
            />
            <span v-if="v$.email.$error" class="message">
                {{ $t('EMAIL_TRANSCRIPT.FORM.EMAIL.ERROR') }}
              </span>
          </label>
        </div>

        <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
          <woot-submit-button
            :button-text="$t('EMAIL_TRANSCRIPT.SUBMIT')"
            :disabled="!isFormValid"
          />
          <button class="button clear" @click.prevent="onCancel">
            {{ $t('EMAIL_TRANSCRIPT.CANCEL') }}
          </button>
        </div>
      </form>
    </div>
  </woot-modal>
</template>
